export default {
  topbar: {
    profileMenuDrop: {
      navbarMenu: {
        subTitle: 'Business Dashboard',
        settings_account: 'My Account',
        settings_password: 'Change Password',
        tour: 'Guided Tour',
        whatIsNew: "What's New?"
      }
    },
    notificationMenuDrop: {
      title: 'Notification',
      markRead: 'Mark all as read',
      all: 'All',
      unread: 'Unread',
      markSeenSuccess: 'Notifications updated successfully',
      groups: {
        today: 'Today',
        yesterday: 'Yesterday',
        '7-days': 'Last 7 days',
        older: 'Olders'
      },
      empty: {
        title: 'No notifications to show yet...',
        description:
          'Alerts about your account, store, transactions and news will be appear here.'
      }
    }
  },
  sidebar: {
    businessMenuDrop: {
      myBusiness: 'My Business',
      addNew: 'Add Business',
      navbarMenu: {
        settings_business_profile: 'My Business Profile',
        'settings-team': 'Manage Team',
        'settings-locations': 'Manage Locations',
        feedback: 'Submit Feedback',
        coin_image: 'My Branded Coin',
        'settings-apps': 'Integrations',
        'coin-network-plan': 'Coin Network Plan',
        'merchant-lp': 'My Landing Page'
      },
      titleList: 'Select a business'
    },
    group: {
      home: 'Home',
      admin: 'Admin',
      'coin-loyalty-settings': 'Rewards Settings',
      'auth-menu': 'My Account',
      'business-menu': 'Business Settings',
      'business-metrics': 'Business Metrics',
      'my-tools': 'My Tools',
      'my-customers': 'My Members',
      members: 'Members',
      'admin/store': 'Coin Store',
      'admin/ticket-request': 'Ticket Request'
    },
    twism_wallet: 'Twism Wallet',
    offers: 'Offers',
    'special-coins-offers': 'Offers',
    'coin-store-merchants': 'Merchants',
    'offer-free-coins': 'Free Coins Campaign',
    'offer-welcome-coins': 'Welcome Coins',
    'social-rewards': 'Social Rewards',
    'referral-program': 'Referral Program',
    revenue_reports: 'Revenue Reports',
    overview_sell_coins: 'Overview',
    offersList: 'Discounts & Coupons',
    birthdayClub: 'Birthday Club',
    selling_coins: 'Gift <strike style="margin: 0 4px;">Cards</strike> Coins',
    sell_coins: 'Gift Cards / Sell Coins',
    marketingCenter: 'Social Media Assets',
    manage_loyalty: 'Rewards Rate',
    coin_image: 'Branded Coin',
    refund_return_policy: 'Refund & Return Policy',
    dashboard: 'All Activities',
    customer: 'Members List',
    transaction_coins_purchased: 'Purchased Coins',
    transaction_coins_rewarded: 'Rewarded Coins',
    transaction_all_transactions: 'Coupon Activities',
    'settings-widget': 'Widget',
    'settings-apps': 'Integrations',
    'settings-activation-emails': 'Email Automation',
    settings_business_profile: 'My Business Profile',
    'settings-team': 'Manage Team',
    'settings-locations': 'Manage Locations',
    settings_account: 'My Account',
    'program-status': 'Program Status',
    tour: 'Guided Tour',
    admin_dashboard: 'Dashboard',
    'add-event': 'Add Event',
    admin_transactions_list: 'Loyalty Transactions',
    admin_online_transactions_list: 'Integration Transactions',
    identify_customers: 'Identify Members',
    admin_flags_list: 'Available Features',
    campaigns_list: 'Referral Campaigns',
    businesses_list: 'Businesses',
    customers_list: 'Members',
    keywords: 'Keywords',
    business_ownership: 'Businesses Ownership',
    admin_identify_customers: 'Segment.io Integrations',
    admin_trigger_broadcasts: 'Trigger Broadcasts',
    settings_password: 'Password',
    'performance-overview': 'Overview',
    'performance-activities': 'Activity',
    'performance-customer-center': 'Member Center',
    'performance-conversions': 'Redemptions',
    'customer-import': 'Invite Customers',
    'invite-customer-in-store': 'Invite My Customers',
    'performance-transactions-center': 'Loyalty Coins'
  }
};
